import useCreationHistory from "../hooks/useCreationHistory";
import VacationTextFields from '../components/VacationTextFields';
import uiI18n from "../i18n";
import { useTranslation as useUiTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import {
  LuArrowLeft,
  LuArrowRight,
  LuBath,
  LuBedDouble,
  LuBriefcaseBusiness,
  LuCamera,
  LuCheck,
  LuCircleDollarSign,
  LuCircleParking,
  LuCookingPot,
  LuFlame,
  LuHouse,
  LuImagePlus,
  LuMinus,
  LuPlus,
  LuSend,
  LuSnowflake,
  LuSofa,
  LuTrees,
  LuTv,
  LuUmbrella,
  LuUserRound,
  LuUsers,
  LuWashingMachine,
  LuWaves,
  LuWifi,
} from "react-icons/lu";

import AddressForm from "../components/CreateSectionAdress";
import ImageUploadSection from "../components/ImageUploadSection";
import { createVacation } from "../Services/vacationsService.jsx";

const TOTAL_STEPS = 7;

const STEPS = [
  {
    id: 1,
    get label() { return uiI18n.t("ui.accommodation"); },
    icon: LuHouse,
  },
  {
    id: 2,
    get label() { return uiI18n.t("ui.amenities"); },
    icon: LuWifi,
  },
  {
    id: 3,
    get label() { return uiI18n.t("ui.address"); },
    icon: LuUmbrella,
  },
  {
    id: 4,
    get label() { return uiI18n.t("ui.capacity"); },
    icon: LuUsers,
  },
  {
    id: 5,
    get label() { return uiI18n.t("ui.rates"); },
    icon: LuCircleDollarSign,
  },
  {
    id: 6,
    get label() { return uiI18n.t("ui.contact"); },
    icon: LuUserRound,
  },
  {
    id: 7,
    get label() { return uiI18n.t("ui.photos_290"); },
    icon: LuImagePlus,
  },
];

const ACCOMMODATION_TYPES = [
  {
    value: "Appartement",
    translationKey: "entirePlace",
    get fallback() { return uiI18n.t("entirePlace"); },
    icon: LuHouse,
  },
  {
    value: "Maison",
    translationKey: "oneRoom",
    get fallback() { return uiI18n.t("oneRoom"); },
    icon: LuBedDouble,
  },
  {
    value: "Commercial",
    translationKey: "sharedRoom",
    get fallback() { return uiI18n.t("sharedRoom"); },
    icon: LuUsers,
  },
];

const EQUIPMENTS = [
  {
    field: "Wifi",
    translationKey: "options.wifi",
    get fallback() { return uiI18n.t("ui.wi_fi"); },
    icon: LuWifi,
  },
  {
    field: "TV",
    translationKey: "options.tv",
    fallback: "Télévision",
    icon: LuTv,
  },
  {
    field: "Kitchen",
    translationKey: "options.cuisine",
    get fallback() { return uiI18n.t("options.cuisine"); },
    icon: LuCookingPot,
  },
  {
    field: "Washer",
    translationKey: "options.lavelinge",
    get fallback() { return uiI18n.t("options.lavelinge"); },
    icon: LuWashingMachine,
  },
  {
    field: "Parking",
    translationKey: "options.Parking",
    get fallback() { return uiI18n.t("ui.parking"); },
    icon: LuCircleParking,
  },
  {
    field: "AC",
    translationKey: "options.climatisation",
    get fallback() { return uiI18n.t("ui.air_conditioning"); },
    icon: LuSnowflake,
  },
  {
    field: "workspace",
    translationKey: "options.espacedetravail",
    get fallback() { return uiI18n.t("options.espacedetravail"); },
    icon: LuBriefcaseBusiness,
  },
  {
    field: "Piscine",
    translationKey: "options.picine",
    get fallback() { return uiI18n.t("options.picine"); },
    icon: LuWaves,
  },
  {
    field: "Barbecue",
    translationKey: "options.barbecue",
    get fallback() { return uiI18n.t("ui.barbecue"); },
    icon: LuFlame,
  },
  {
    field: "Garden",
    translationKey: "options.jardin",
    get fallback() { return uiI18n.t("options.jardin"); },
    icon: LuTrees,
  },
  {
    field: "BeachAccess",
    translationKey: "options.accesauplage",
    get fallback() { return uiI18n.t("amenities.beachAccess"); },
    icon: LuUmbrella,
  },
  {
    field: "Camera",
    translationKey: "options.camera",
    get fallback() { return uiI18n.t("amenities.camera"); },
    icon: LuCamera,
  },
];

const COUNTERS = [
  {
    field: "MaxGuests",
    translationKey: "guestNumbers",
    get fallback() { return uiI18n.t("ui.guests_165"); },
    icon: LuUsers,
  },
  {
    field: "Chambres",
    translationKey: "bedrooms",
    get fallback() { return uiI18n.t("rooms.bedrooms"); },
    icon: LuHouse,
  },
  {
    field: "Lits",
    translationKey: "beds",
    fallback: "Lits",
    icon: LuBedDouble,
  },
  {
    field: "SallesBains",
    translationKey: "bathrooms",
    get fallback() { return uiI18n.t("ui.bathrooms_446"); },
    icon: LuBath,
  },
];

function CreateVacation() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const auth = getAuth();

  const { step: currentSection, setStep: setCurrentSection, markDirty, markSaved } = useCreationHistory();
  const [submitting, setSubmitting] = useState(false);
  const [authReady, setAuthReady] = useState(false);

  const [formData, setFormData] = useState({
    Libelle: "",
    Type: "rent",
    Bien: "",
    Category: "Appartement",

    Parking: false,
    meuble: false,
    Kitchen: false,
    AC: false,
    Piscine: false,
    Garden: false,
    Barbecue: false,
    BeachAccess: false,
    workspace: false,
    Washer: false,
    Wifi: false,
    TV: false,
    Camera: false,

    Chambres: 0,
    SallesBains: 0,
    MaxGuests: 1,
    Lits: 0,
    Surface: "",

    Latitude: null,
    Longitude: null,
    Ville: "",
    Delegation: "",
    CodePostal: "",
    Pays: "Tunisie",
    Adresse: "",

    Description: "",

    Prix: "",
    PrixReduit: "",
    Offre: false,
    OffreWeek: 0,
    OffreMonth: 0,

    UrlImages: "",
    images: [],

    Email: "",
    Tel: "",
    uid: "",
    name: "",
  });

  const {
    Category,
    Wifi,
    TV,
    Kitchen,
    Washer,
    Parking,
    AC,
    workspace,
    Piscine,
    Barbecue,
    Garden,
    BeachAccess,
    Camera,
    Prix,
    PrixReduit,
    Offre,
    OffreWeek,
    OffreMonth,
    Email,
    Tel,
    images,
  } = formData;

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (!user) {
        setAuthReady(true);
        return;
      }

      setFormData((previousValue) => ({
        ...previousValue,
        Email: previousValue.Email || user.email || "",
        uid: user.uid,
        name: user.displayName || "",
      }));

      setAuthReady(true);
    });

    return unsubscribe;
  }, [auth]);

  const progressPercentage =
    ((currentSection - 1) / (TOTAL_STEPS - 1)) * 100;

  const updateField = (field, value) => {
    setFormData((previousValue) => ({
      ...previousValue,
      [field]: value,
    }));
  };

  const onChange = (event) => {
    const { id, value, type, checked } = event.target;

    let normalizedValue = value;

    if (type === "checkbox") {
      normalizedValue = checked;
    } else if (value === "true") {
      normalizedValue = true;
    } else if (value === "false") {
      normalizedValue = false;
    }

    updateField(id, normalizedValue);
  };

  const onImagesChange = (selectedImages) => {
    const normalizedImages = Array.isArray(selectedImages)
      ? selectedImages
      : [];

    setFormData((previousValue) => ({
      ...previousValue,
      UrlImages: normalizedImages
        .map((image) =>
          typeof image === "string" ? image : image?.name
        )
        .filter(Boolean)
        .join(","),
      images: normalizedImages,
    }));
  };

  const handleCounterChange = (field, operation) => {
    setFormData((previousValue) => ({
      ...previousValue,
      [field]:
        operation === "increase"
          ? Number(previousValue[field] || 0) + 1
          : Math.max(
              Number(previousValue[field] || 0) - 1,
              field === "MaxGuests" ? 1 : 0
            ),
    }));
  };

  const validateCurrentStep = () => {
    if (currentSection === 1 && !Category) {
      toast.error(
        t(
          "vacation.category_required",
          "Sélectionnez un type de logement."
        )
      );

      return false;
    }

    if (currentSection === 3) {
      if (
        !formData.Ville ||
        !formData.Delegation
      ) {
        toast.error(
          t(
            "create.address_fields_required",
            "Veuillez renseigner la ville et la délégation."
          )
        );

        return false;
      }
    }

    if (currentSection === 4) {
      if (Number(formData.MaxGuests) < 1) {
        toast.error(
          t(
            "vacation.guests_required",
            "Le logement doit accueillir au moins une personne."
          )
        );

        return false;
      }
    }

    if (currentSection === 5) {
      if (Prix !== "" && (!Number.isFinite(Number(Prix)) || Number(Prix) <= 0)) {
        toast.error(
          t(
            "vacationPublication.invalidPrice",
            "Veuillez renseigner un prix valide."
          )
        );

        return false;
      }

      if (
        Offre &&
        (!PrixReduit ||
          Number(PrixReduit) <= 0 ||
          Number(PrixReduit) >= Number(Prix))
      ) {
        toast.error(
          t(
            "vacation.discount_error",
            "Le prix réduit doit être inférieur au prix normal."
          )
        );

        return false;
      }
    }

    if (currentSection === 6) {
      if (!Email?.trim() || !Tel?.trim()) {
        toast.error(
          t(
            "vacation.contact_required",
            "Renseignez votre e-mail et votre téléphone."
          )
        );

        return false;
      }
    }

    return true;
  };

  const handleContinue = () => {
    if (!validateCurrentStep()) {
      return;
    }

    setCurrentSection((previousValue) =>
      Math.min(previousValue + 1, TOTAL_STEPS)
    );

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handlePrevious = () => {
    setCurrentSection((previousValue) =>
      Math.max(previousValue - 1, 1)
    );

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const createClick = async (event) => {
    event.preventDefault();

    if (submitting) {
      return;
    }

    const currentUser = auth.currentUser;

    if (!currentUser) {
      toast.error(
        t(
          "vacation.login_required",
          "Vous devez être connecté pour publier une annonce."
        )
      );

      navigate("/SignIn");
      return;
    }

    if (!Array.isArray(images) || images.length === 0) {
      toast.error(
        t(
          "vacation.photos_required",
          "Ajoutez au moins une photo."
        )
      );

      return;
    }

    setSubmitting(true);

    try {
      const payload = {
        ...formData,

        Prix: Number(formData.Prix),
        PrixReduit: formData.Offre
          ? Number(formData.PrixReduit)
          : 0,

        OffreWeek: Number(formData.OffreWeek),
        OffreMonth: Number(formData.OffreMonth),

        Chambres: Number(formData.Chambres),
        SallesBains: Number(formData.SallesBains),
        MaxGuests: Number(formData.MaxGuests),
        Lits: Number(formData.Lits),
        Surface: Number(formData.Surface || 0),

        Latitude: formData.Latitude == null ? undefined : Number(formData.Latitude),
        Longitude: formData.Longitude == null ? undefined : Number(formData.Longitude),

        uid: currentUser.uid,
        Email: formData.Email || currentUser.email || "",
        name: currentUser.displayName || "",
      };

      const result = await createVacation(
        payload,
        payload.images
      );

      toast.success(
        result?.Message ||
          t(
            "vacation.create_success",
            "Votre location de vacances a été publiée."
          )
      );

      markSaved();
      navigate("/myAds");
    } catch (error) {
      console.error(
        "Erreur lors de la création de la location :",
        error
      );

      toast.error(
        error?.message ||
          t(
            "vacation.create_error",
            "Impossible de publier votre annonce."
          )
      );
    } finally {
      setSubmitting(false);
    }
  };

  if (!authReady) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center bg-slate-50">
        <span className="h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-green-600" />
      </div>
    );
  }

  return (
    <main className="min-h-screen bg-slate-50 px-4 py-8 sm:px-6 lg:px-8 lg:py-12">
      <div className="mx-auto max-w-5xl">
        {/* Titre */}
        <header className="mb-8 text-center">
          <p className="text-xs font-black uppercase tracking-[0.2em] text-green-600"> {uiI18n.t("ui.lina_immo_holidays")} </p>

          <h1 className="mt-3 text-3xl font-black text-slate-950 sm:text-4xl">
            {t(
              "vacation.create_title",
              "Publier une location de vacances"
            )}
          </h1>

          <p className="mx-auto mt-3 max-w-2xl text-sm leading-6 text-slate-500 sm:text-base">
            {t(
              "vacation.create_description",
              "Présentez votre logement, ses équipements et ses tarifs en quelques étapes."
            )}
          </p>
        </header>

        {/* Progression */}
        <div className="mb-7 rounded-3xl border border-slate-100 bg-white p-4 shadow-sm sm:p-6">
          <div className="relative">
            <div className="absolute start-0 end-0 top-5 hidden h-1 rounded-full bg-slate-100 sm:block">
              <div
                className="h-full rounded-full bg-green-600 transition-all duration-500"
                style={{
                  width: `${progressPercentage}%`,
                }}
              />
            </div>

            <div className="relative grid grid-cols-4 gap-3 sm:grid-cols-7">
              {STEPS.map((step) => {
                const Icon = step.icon;
                const completed = step.id < currentSection;
                const active = step.id === currentSection;

                return (
                  <div
                    key={step.id}
                    className="flex flex-col items-center text-center"
                  >
                    <span
                      className={`
                        relative z-10 flex h-10 w-10 items-center
                        justify-center rounded-full border-2
                        text-sm font-black transition
                        ${
                          completed
                            ? "border-green-600 bg-green-600 text-white"
                            : active
                              ? "border-green-600 bg-white text-green-600 shadow-lg shadow-green-600/15"
                              : "border-slate-200 bg-white text-slate-400"
                        }
                      `}
                    >
                      {completed ? (
                        <LuCheck size={17} />
                      ) : (
                        <Icon size={17} />
                      )}
                    </span>

                    <span
                      className={`
                        mt-2 text-[10px] font-bold sm:text-xs
                        ${
                          active
                            ? "text-green-700"
                            : completed
                              ? "text-slate-700"
                              : "text-slate-400"
                        }
                      `}
                    >
                      {step.label}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <form onChangeCapture={markDirty} onClickCapture={(event) => { if (event.target.closest("button")) markDirty(); }}
          id="CreateVacation"
          onSubmit={createClick}
          className="rounded-3xl border border-slate-100 bg-white p-5 shadow-xl shadow-slate-900/5 sm:p-8"
        >
          {/* Étape 1 */}
          {currentSection === 1 && (
            <StepContainer
              eyebrow={t("edit.step", { number: 1 })}
              title={t(
                "vacation.accommodation_title",
                "Quel type de logement proposez-vous ?"
              )}
              description={t(
                "vacation.accommodation_description",
                "Sélectionnez la formule correspondant à votre location."
              )}
            >
              <div className="grid gap-4 md:grid-cols-3">
                {ACCOMMODATION_TYPES.map((item) => (
                  <AccommodationButton
                    key={item.value}
                    active={Category === item.value}
                    icon={item.icon}
                    label={t(
                      item.translationKey,
                      item.fallback
                    )}
                    onClick={() =>
                      updateField("Category", item.value)
                    }
                  />
                ))}
              </div>

              <VacationTextFields title={formData.Libelle} description={formData.Description} onChange={onChange} />
              <StepActions
                onNext={handleContinue}
                nextLabel={t("continue", "Continuer")}
              />
            </StepContainer>
          )}

          {/* Étape 2 */}
          {currentSection === 2 && (
            <StepContainer
              eyebrow={t("edit.step", { number: 2 })}
              title={t(
                "options.description",
                "Équipements et services"
              )}
              description={t(
                "vacation.equipment_description",
                "Sélectionnez les équipements disponibles dans votre logement."
              )}
            >
              <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
                {EQUIPMENTS.map((equipment) => (
                  <EquipmentToggle
                    key={equipment.field}
                    icon={equipment.icon}
                    label={t(
                      equipment.translationKey,
                      equipment.fallback
                    )}
                    active={Boolean(
                      formData[equipment.field]
                    )}
                    onClick={() =>
                      updateField(
                        equipment.field,
                        !formData[equipment.field]
                      )
                    }
                  />
                ))}
              </div>

              <StepActions
                onPrevious={handlePrevious}
                onNext={handleContinue}
                previousLabel={t(
                  "previous",
                  "Précédent"
                )}
                nextLabel={t("continue", "Continuer")}
              />
            </StepContainer>
          )}

          {/* Étape 3 */}
          {currentSection === 3 && (
            <StepContainer
              eyebrow={t("edit.step", { number: 3 })}
              title={t(
                "vacation.address_title",
                "Localisez le logement"
              )}
              description={t(
                "vacation.address_description",
                "Indiquez l’adresse et vérifiez la position sur la carte."
              )}
            >
              <AddressForm
                formData={formData}
                setFormData={setFormData}
                handlePrevious={handlePrevious}
                handleContinue={handleContinue}
              />
            </StepContainer>
          )}

          {/* Étape 4 */}
          {currentSection === 4 && (
            <StepContainer
              eyebrow={t("edit.step", { number: 4 })}
              title={t(
                "details",
                "Capacité du logement"
              )}
              description={t(
                "vacation.capacity_description",
                "Indiquez le nombre de voyageurs, chambres, lits et salles de bain."
              )}
            >
              <div className="grid gap-4 md:grid-cols-2">
                {COUNTERS.map((counter) => (
                  <Counter
                    key={counter.field}
                    icon={counter.icon}
                    label={t(
                      counter.translationKey,
                      counter.fallback
                    )}
                    value={formData[counter.field]}
                    onDecrease={() =>
                      handleCounterChange(
                        counter.field,
                        "decrease"
                      )
                    }
                    onIncrease={() =>
                      handleCounterChange(
                        counter.field,
                        "increase"
                      )
                    }
                  />
                ))}
              </div>

              <StepActions
                onPrevious={handlePrevious}
                onNext={handleContinue}
                previousLabel={t(
                  "previous",
                  "Précédent"
                )}
                nextLabel={t("continue", "Continuer")}
              />
            </StepContainer>
          )}

          {/* Étape 5 */}
          {currentSection === 5 && (
            <StepContainer
              eyebrow={t("edit.step", { number: 5 })}
              title={t(
                "vacation.pricing_title",
                "Définissez vos tarifs"
              )}
              description={t(
                "vacation.pricing_description",
                "Indiquez le tarif journalier et vos réductions éventuelles."
              )}
            >
              <div className="grid gap-5 md:grid-cols-2">
                <FormField
                  label={t(
                    "vacationPublication.optionalPrice",
                    "Prix par nuit (facultatif)"
                  )}
                  htmlFor="Prix"
                >
                  <PriceInput
                    id="Prix"
                    value={Prix}
                    onChange={onChange}
                  />
                </FormField>

                <BooleanChoice
                  label={t(
                    "offer",
                    "Offre promotionnelle"
                  )}
                  value={Offre}
                  onChange={(value) => {
                    updateField("Offre", value);

                    if (!value) {
                      updateField("PrixReduit", "");
                    }
                  }}
                />
              </div>

              {Offre && (
                <div className="mt-5">
                  <FormField
                    label={t(
                      "vacation.discount_price",
                      "Prix réduit"
                    )}
                    htmlFor="PrixReduit"
                    required
                  >
                    <PriceInput
                      id="PrixReduit"
                      value={PrixReduit}
                      onChange={onChange}
                    />
                  </FormField>
                </div>
              )}

              <div className="mt-6 grid gap-5 md:grid-cols-2">
                <DiscountSlider
                  label={t(
                    "SoldeW",
                    "Réduction hebdomadaire"
                  )}
                  description={t(
                    "SoldeW_",
                    "Pour un séjour d’une semaine"
                  )}
                  value={OffreWeek}
                  onChange={(value) =>
                    updateField("OffreWeek", value)
                  }
                />

                <DiscountSlider
                  label={t(
                    "SoldeM",
                    "Réduction mensuelle"
                  )}
                  description={t(
                    "SoldeM_",
                    "Pour un séjour d’un mois"
                  )}
                  value={OffreMonth}
                  onChange={(value) =>
                    updateField("OffreMonth", value)
                  }
                />
              </div>

              <StepActions
                onPrevious={handlePrevious}
                onNext={handleContinue}
                previousLabel={t(
                  "previous",
                  "Précédent"
                )}
                nextLabel={t("continue", "Continuer")}
              />
            </StepContainer>
          )}

          {/* Étape 6 */}
          {currentSection === 6 && (
            <StepContainer
              eyebrow={t("edit.step", { number: 6 })}
              title={t(
                "Contacts",
                "Vos coordonnées"
              )}
              description={t(
                "vacation.contact_description",
                "Ces informations permettront aux voyageurs de vous contacter."
              )}
            >
              <div className="grid gap-5 md:grid-cols-2">
                <FormField
                  label={t("email", "E-mail")}
                  htmlFor="Email"
                  required
                >
                  <input
                    required
                    type="email"
                    id="Email"
                    value={Email}
                    onChange={onChange}
                    autoComplete="email"
                    className={inputClassName}
                  />
                </FormField>

                <FormField
                  label={t(
                    "numtel",
                    "Téléphone"
                  )}
                  htmlFor="Tel"
                  required
                >
                  <input
                    required
                    type="tel"
                    id="Tel"
                    value={Tel}
                    onChange={(event) => {
                      const normalizedValue =
                        event.target.value
                          .replace(/[^0-9+\s]/g, "")
                          .slice(0, 20);

                      updateField("Tel", normalizedValue);
                    }}
                    autoComplete="tel"
                    placeholder="+216 00 000 000"
                    className={inputClassName}
                  />
                </FormField>
              </div>

              <StepActions
                onPrevious={handlePrevious}
                onNext={handleContinue}
                previousLabel={t(
                  "previous",
                  "Précédent"
                )}
                nextLabel={t("continue", "Continuer")}
              />
            </StepContainer>
          )}

          {/* Étape 7 */}
          {currentSection === 7 && (
            <StepContainer
              eyebrow={t("edit.step", { number: 7 })}
              title={t(
                "vacation.photos_title",
                "Ajoutez les photos du logement"
              )}
              description={t(
                "vacation.photos_description",
                "Choisissez des photos lumineuses qui présentent les pièces et les équipements."
              )}
            >
              <ImageUploadSection
                maxImages={12}
                initialImages={images}
                onImagesChange={onImagesChange}
                handlePrevious={handlePrevious}
              />

              {/* Un seul bouton de publication */}
              <div className="mt-7 flex justify-end border-t border-slate-100 pt-6">
                <button
                  type="submit"
                  disabled={submitting}
                  className="
                    inline-flex h-12 items-center justify-center gap-2
                    rounded-2xl bg-green-600 px-7 text-sm
                    font-black text-white shadow-lg
                    shadow-green-600/20 transition-all
                    hover:-translate-y-0.5 hover:bg-green-700
                    disabled:cursor-not-allowed
                    disabled:bg-slate-300 disabled:shadow-none
                    focus:outline-none focus:ring-4
                    focus:ring-green-500/20
                  "
                >
                  {submitting ? (
                    <>
                      <span className="h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white" />
                      {t(
                        "sending",
                        "Publication..."
                      )}
                    </>
                  ) : (
                    <>
                      <LuSend size={17} />

                      {t(
                        "vacation.publish",
                        "Publier la location"
                      )}
                    </>
                  )}
                </button>
              </div>
            </StepContainer>
          )}
        </form>
      </div>
    </main>
  );
}

const inputClassName = `
  h-12 w-full rounded-2xl border border-slate-200
  bg-white px-4 text-sm font-medium text-slate-900
  outline-none transition placeholder:text-slate-400
  hover:border-slate-300 focus:border-green-500
  focus:ring-4 focus:ring-green-500/10
`;

const secondaryButtonClass = `
  inline-flex h-12 items-center justify-center gap-2
  rounded-2xl border border-slate-200 bg-white px-6
  text-sm font-bold text-slate-700 transition
  hover:border-slate-300 hover:bg-slate-100
  focus:outline-none focus:ring-4 focus:ring-slate-500/10
`;

function StepContainer({
  eyebrow,
  title,
  description,
  children,
}) {
  useUiTranslation();
  return (
    <section>
      <div className="mb-7">
        <p className="text-xs font-black uppercase tracking-[0.18em] text-green-600">
          {eyebrow}
        </p>

        <h2 className="mt-2 text-2xl font-black text-slate-950">
          {title}
        </h2>

        <p className="mt-2 text-sm leading-6 text-slate-500">
          {description}
        </p>
      </div>

      {children}
    </section>
  );
}

function AccommodationButton({
  active,
  icon: Icon,
  label,
  onClick,
}) {
  useUiTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        flex min-h-32 flex-col items-center justify-center
        gap-3 rounded-3xl border p-5 text-center
        transition-all focus:outline-none focus:ring-4
        focus:ring-green-500/15
        ${
          active
            ? "border-green-600 bg-green-600 text-white shadow-lg shadow-green-600/15"
            : "border-slate-200 bg-white text-slate-700 hover:border-green-300 hover:bg-green-50 hover:text-green-700"
        }
      `}
    >
      <Icon size={27} />

      <span className="text-sm font-black">
        {label}
      </span>
    </button>
  );
}

function EquipmentToggle({
  active,
  icon: Icon,
  label,
  onClick,
}) {
  useUiTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={`
        flex min-h-16 items-center gap-3 rounded-2xl
        border px-4 py-3 text-start transition
        focus:outline-none focus:ring-4 focus:ring-green-500/15
        ${
          active
            ? "border-green-600 bg-green-50 text-green-700"
            : "border-slate-200 bg-white text-slate-600 hover:border-green-300 hover:bg-green-50/50"
        }
      `}
    >
      <span
        className={`
          flex h-10 w-10 shrink-0 items-center
          justify-center rounded-xl
          ${
            active
              ? "bg-green-600 text-white"
              : "bg-slate-100 text-slate-500"
          }
        `}
      >
        <Icon size={19} />
      </span>

      <span className="flex-1 text-sm font-bold">
        {label}
      </span>

      {active && (
        <LuCheck
          size={17}
          className="shrink-0 text-green-600"
        />
      )}
    </button>
  );
}

function Counter({
  icon: Icon,
  label,
  value,
  onDecrease,
  onIncrease,
}) {
  useUiTranslation();
  return (
    <div className="flex items-center justify-between rounded-2xl border border-slate-200 bg-slate-50 p-4">
      <span className="flex items-center gap-2 text-sm font-black text-slate-700">
        <Icon size={18} className="text-green-600" />
        {label}
      </span>

      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onDecrease}
          className="flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-700 transition hover:border-green-300 hover:text-green-600"
        >
          <LuMinus size={16} />
        </button>

        <span className="min-w-7 text-center text-lg font-black text-slate-900">
          {value}
        </span>

        <button
          type="button"
          onClick={onIncrease}
          className="flex h-9 w-9 items-center justify-center rounded-full bg-green-600 text-white transition hover:bg-green-700"
        >
          <LuPlus size={16} />
        </button>
      </div>
    </div>
  );
}

function BooleanChoice({
  label,
  value,
  onChange,
}) {
  useUiTranslation();
  return (
    <div>
      <p className="mb-2 text-sm font-black text-slate-700">
        {label}
      </p>

      <div className="grid grid-cols-2 gap-2">
        <button
          type="button"
          onClick={() => onChange(true)}
          className={`
            h-12 rounded-2xl text-sm font-bold transition
            ${
              value
                ? "bg-green-600 text-white"
                : "border border-slate-200 bg-white text-slate-600 hover:bg-green-50"
            }
          `}
        > {uiI18n.t("ui.yes")} </button>

        <button
          type="button"
          onClick={() => onChange(false)}
          className={`
            h-12 rounded-2xl text-sm font-bold transition
            ${
              !value
                ? "bg-slate-950 text-white"
                : "border border-slate-200 bg-white text-slate-600 hover:bg-slate-100"
            }
          `}
        > {uiI18n.t("ui.no")} </button>
      </div>
    </div>
  );
}

function PriceInput({
  id,
  value,
  onChange,
}) {
  useUiTranslation();
  return (
    <div className="relative">
      <input
        required={id !== "Prix"}
        type="number"
        id={id}
        min="0"
        max="50000000"
        value={value}
        onChange={onChange}
        placeholder="0"
        className={`${inputClassName} pe-20 text-lg font-black`}
      />

      <span className="pointer-events-none absolute end-4 top-1/2 -translate-y-1/2 text-xs font-black text-slate-400">
        TND
      </span>
    </div>
  );
}

function DiscountSlider({
  label,
  description,
  value,
  onChange,
}) {
  useUiTranslation();
  return (
    <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-sm font-black text-slate-800">
            {label}
          </p>

          <p className="mt-1 text-xs text-slate-500">
            {description}
          </p>
        </div>

        <span className="rounded-full bg-green-100 px-3 py-1 text-sm font-black text-green-700">
          {value} %
        </span>
      </div>

      <input
        type="range"
        min="0"
        max="100"
        step="5"
        value={value}
        onChange={(event) =>
          onChange(Number(event.target.value))
        }
        className="mt-5 h-2 w-full cursor-pointer accent-green-600"
      />
    </div>
  );
}

function FormField({
  label,
  htmlFor,
  required,
  children,
}) {
  useUiTranslation();
  return (
    <div>
      <label
        htmlFor={htmlFor}
        className="mb-2 block text-sm font-black text-slate-700"
      >
        {label}

        {required && (
          <span className="ms-1 text-red-500">*</span>
        )}
      </label>

      {children}
    </div>
  );
}

function StepActions({
  onPrevious,
  onNext,
  previousLabel,
  nextLabel,
}) {
  useUiTranslation();
  return (
    <div
      className={`
        mt-8 flex flex-col-reverse gap-3
        border-t border-slate-100 pt-6 sm:flex-row
        ${
          onPrevious
            ? "sm:justify-between"
            : "sm:justify-end"
        }
      `}
    >
      {onPrevious && (
        <button
          type="button"
          onClick={onPrevious}
          className={secondaryButtonClass}
        >
          <LuArrowLeft
            size={17}
            className="rtl:rotate-180"
          />

          {previousLabel}
        </button>
      )}

      {onNext && (
        <button
          type="button"
          onClick={onNext}
          className="
            inline-flex h-12 items-center justify-center gap-2
            rounded-2xl bg-slate-950 px-7 text-sm
            font-black text-white shadow-lg transition-all
            hover:-translate-y-0.5 hover:bg-green-600
            focus:outline-none focus:ring-4
            focus:ring-green-500/20
          "
        >
          {nextLabel}

          <LuArrowRight
            size={17}
            className="rtl:rotate-180"
          />
        </button>
      )}
    </div>
  );
}

export default CreateVacation;
